




































import Vue from 'vue'

export default Vue.extend({
  name: 'Testimonial',
  data() {
    return {
      referenceList: [
        { uid: `1`, path: `https://stripe.com/img/v3/payments/overview/logos/kickstarter.svg`, description: `moi` },
        { uid: `3`, path: `https://stripe.com/img/v3/payments/overview/logos/kickstarter.svg`, description: `hello` },
        { uid: `5`, path: `https://stripe.com/img/v3/payments/overview/logos/kickstarter.svg`, description: `testimonial` }
      ]
    }
  }
})
